<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a
          class="navbar-brand d-flex align-items-center ms-1 me-3"
          href="/"
          title="PSCO Application Portal"
          aria-label="PSCO Application Portal"
        >
          <SiteLogoText height="40" />
          <span class="navbar-brand-site d-none d-sm-block ms-2">
            GridUnity <span class="navbar-brand-detail">Interconnection Portal</span>
          </span>
        </a>
        <EnvBadge />

        <SiteNavigation />
      </div>
    </nav>
  </header>
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import SiteNavigation from '@shared/components/SiteNavigation.vue'
import SiteLogoText from './SiteLogoText.vue'
</script>
